import { Link, NavLink, useNavigate } from "react-router-dom";
import { adminLogout } from "../../lib/api/index";
import { logger } from "../../lib/logger";

export default function AdminLayout({ admin, children }) {
  const navigate = useNavigate();

  const onLogout = async () => {
    try {
      await adminLogout();
    } catch (err) {
      logger.error("admin_logout_failed", { err: err?.response?.status });
    }
    navigate("/admin/login", { replace: true });
  };

  const tab = ({ isActive }) => ({
    padding: "8px 14px",
    borderRadius: 6,
    fontSize: 13,
    letterSpacing: "0.04em",
    textDecoration: "none",
    color: isActive ? "var(--sf-gold)" : "var(--sf-offwhite)",
    border: isActive ? "1px solid var(--sf-gold-dim)" : "1px solid transparent",
    backgroundColor: isActive ? "rgba(201,162,74,0.06)" : "transparent",
  });

  return (
    <div className="sf-app" data-testid="admin-layout">
      <header style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "16px 24px",
        borderBottom: "1px solid #22262B",
        backgroundColor: "var(--sf-charcoal)",
      }} data-testid="admin-header">
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Link to="/admin" style={{ textDecoration: "none", color: "var(--sf-offwhite)" }}>
            <strong className="sf-display">SystemForge AI</strong>
            <span className="sf-mono sf-muted-text" style={{ marginLeft: 8 }}>· admin</span>
          </Link>
          <nav style={{ display: "flex", gap: 6, marginLeft: 12 }}>
            <NavLink to="/admin" end style={tab} data-testid="admin-nav-overview">Overview</NavLink>
            <NavLink to="/admin/audits" style={tab} data-testid="admin-nav-audits">Audits</NavLink>
            <NavLink to="/admin/payments" style={tab} data-testid="admin-nav-payments">Payments</NavLink>
            <NavLink to="/admin/consultations" style={tab} data-testid="admin-nav-consultations">Consultations</NavLink>
            <NavLink to="/admin/implementation-requests" style={tab} data-testid="admin-nav-impl">Implementation</NavLink>
          </nav>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span className="sf-mono sf-muted-text" style={{ fontSize: 12 }} data-testid="admin-current-email">
            {admin?.email || "—"}
          </span>
          <button
            type="button"
            onClick={onLogout}
            className="sf-btn-secondary"
            style={{ padding: "6px 14px", fontSize: 12 }}
            data-testid="admin-logout-btn"
          >
            Log out
          </button>
        </div>
      </header>
      <main style={{ padding: "32px 24px", maxWidth: 1280, margin: "0 auto" }} data-testid="admin-content">
        {children}
      </main>
    </div>
  );
}
